import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 会员申请弹窗
    applyShow: false
  },
  mutations: {
    SET_APPLY_SHOW: (state, show) => {
      state.applyShow = show
    }
  },
  actions: {
  },
  modules: {
  }
})
